// src/components/Dashboard/Dashboard.jsx
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { signOut } from 'firebase/auth';
import { FiBriefcase, FiMail, FiSettings, FiLogOut, FiBookOpen } from 'react-icons/fi';
import './Dashboard.css';
import ServicesAdmin from '../ServicesAdmin/ServicesAdmin';
import BlogAdmin from '../BlogAdmin/BlogAdmin';
import { auth } from '../firebase/firebase-config';
import ContactAdmin from '../ContactAdmin/ContactAdmin';

function Dashboard() {
  const [activeTab, setActiveTab] = useState('services');
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await signOut(auth);
      navigate('/');
    } catch (error) {
      console.error("Güvenli çıkış işlemi sırasında bir hata meydana geldi:", error);
    }
  };

  return (
    <div className="admin-dashboard">
      {/* Sol Menü (Sidebar) */}
      <aside className="dashboard-sidebar">
        <div className="sidebar-header">
          <h3>Yönetim <span className="gold-text">Paneli</span></h3>
          <p>Av. Emre Uygun</p>
        </div>

        <nav className="sidebar-nav">
          <button 
            className={activeTab === 'services' ? 'nav-item active' : 'nav-item'} 
            onClick={() => setActiveTab('services')}
          >
            <FiBriefcase /> Çalışma Alanları
          </button>

          <button 
            className={activeTab === 'blogs' ? 'nav-item active' : 'nav-item'} 
            onClick={() => setActiveTab('blogs')}
          >
            <FiBookOpen /> Blog ve Makaleler
          </button>

          <button 
            className={activeTab === 'messages' ? 'nav-item active' : 'nav-item'} 
            onClick={() => setActiveTab('messages')}
          >
            <FiMail /> Gelen Mesajlar
          </button>

          <button 
            className={activeTab === 'settings' ? 'nav-item active' : 'nav-item'} 
            onClick={() => setActiveTab('settings')}
          >
            <FiSettings /> Site Ayarları
          </button>
        </nav>

        <div className="sidebar-footer">
          <button className="logout-btn" onClick={handleLogout}>
            <FiLogOut /> Güvenli Çıkış
          </button>
        </div>
      </aside>

      {/* Sağ Ana İçerik Alanı */}
      <main className="dashboard-content">
        <header className="content-header">
          <h2>
            {activeTab === 'services' && 'Çalışma Alanlarını Yönetin'}
            {activeTab === 'blogs' && 'Hukuki Makale ve Blog Yönetimi'}
            {activeTab === 'messages' && 'Müvekkil İletişim Mesajları'}
            {activeTab === 'settings' && 'Genel Web Sitesi Ayarları'}
          </h2>
          <span className="admin-badge">Admin Yetkili</span>
        </header>

        <div className="content-body">
          {activeTab === 'services' && (
            <div className="tab-pane">
              <ServicesAdmin />
            </div>
          )}

          {activeTab === 'blogs' && (
            <div className="tab-pane">
              <BlogAdmin />
            </div>
          )}

          {activeTab === 'messages' && (
            <div className="tab-pane">
              <ContactAdmin /> {/* <--- Gelen mesajlar paneli aktif edildi kanka */}
            </div>
          )}

          {activeTab === 'settings' && (
            <div className="tab-pane">
              <p className="section-placeholder-text">
                Ofis iletişim bilgileri, resmi telefon numaraları, adres detayları ve sosyal medya bağlantılarını bu panel üzerinden merkezi olarak yönetebilirsiniz.
              </p>
            </div>
          )}
        </div>
      </main>
    </div>
  );
}

export default Dashboard;